/*
  PDP — "Layer your ritual" cross-sell Add-to-cart (Pause Rituals)
  Adds the chosen add-on's first available variant to the cart via /cart/add.js and
  refreshes Dawn's cart UI (cart-drawer or cart-notification). Falls back to updating
  just the cart count bubble when neither cart element is present (cart type = page).
*/
(function () {
  if (window.__pdpLayerInit) return;
  window.__pdpLayerInit = true;

  document.addEventListener('click', function (e) {
    // shared trigger: any button with [data-cart-add] (cross-sell + pick-and-choose)
    var btn = e.target.closest('[data-cart-add]');
    if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    addToCart(btn, variantId, btn.getAttribute('data-product-id'));
  });

  function addToCart(btn, variantId, productId) {
    var label = btn.querySelector('[data-cart-add-label]') || btn;
    var original = label.getAttribute('data-label') || label.textContent;
    btn.classList.add('is-loading');

    var cart =
      document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    // cart-notification needs the product id to render its product-specific section
    if (cart && cart.tagName === 'CART-NOTIFICATION' && productId) {
      cart.productId = productId;
    }

    var sections = [];
    if (cart && typeof cart.getSectionsToRender === 'function') {
      try {
        sections = cart.getSectionsToRender().map(function (s) {
          return s.id;
        });
      } catch (err) {
        sections = [];
      }
    }
    if (!sections.length) sections = ['cart-icon-bubble'];

    var body = {
      id: Number(variantId),
      quantity: 1,
      sections: sections.join(','),
      sections_url: window.location.pathname,
    };

    var url =
      window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        if (res.status) {
          flash(btn, label, original, label.textContent || 'Unavailable');
          return;
        }
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(res);
        } else {
          updateBubble(res);
        }
        flash(btn, label, original, 'Added ✓');
        // let cart-aware UI (e.g. the quiz-result discount bar) refresh
        document.dispatchEvent(new CustomEvent('pr:cart-added'));
      })
      .catch(function () {
        flash(btn, label, original, original);
      })
      .finally(function () {
        btn.classList.remove('is-loading');
      });
  }

  function flash(btn, label, original, text) {
    label.textContent = text;
    setTimeout(function () {
      label.textContent = original;
    }, 1400);
  }

  function updateBubble(res) {
    if (!res.sections || !res.sections['cart-icon-bubble']) return;
    var el = document.getElementById('cart-icon-bubble');
    if (!el) return;
    var doc = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
    var inner = doc.querySelector('.shopify-section') || doc.body;
    el.innerHTML = inner.innerHTML;
  }
})();
